import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import cx from 'classnames'

import { Button, Colorway } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import styles from '../styles.module.css'

interface Props {
  loading: boolean
  children: React.ReactElement
  failed: boolean
  handleRetry: () => void
  label: string
}

const LoadingFieldList = ({ loading, children, failed, handleRetry, label }: Props) => {
  if (failed) {
    return (
      <div className={cx(styles.row)}>
        <div className={styles.empty}>
          <Colorway type="2" size="medium">
            <Icon name="cw-empty-search" />
          </Colorway>
          <h4>{`Failed to load ${label} preferences`}</h4>
          <Button type="primary" onClick={handleRetry} loading={loading}>
            Try again
          </Button>
        </div>
      </div>
    )
  }
  if (loading) {
    return (
      <div className={styles.row}>
        <SkeletonTheme color="var(--color-p1-5)" highlightColor="var(--color-p1-3)">
          <div className={styles.skeletonItem}>
            <Skeleton height="20px" width="300px" />
          </div>
          <div className={styles.skeletonItem}>
            <Skeleton height="20px" width="200px" />
          </div>
          <div className={styles.skeletonItem}>
            <Skeleton height="20px" width="300px" />
          </div>
          <div className={styles.skeletonItem}>
            <Skeleton height="20px" width="200px" />
          </div>
        </SkeletonTheme>
      </div>
    )
  }
  return children
}

export default LoadingFieldList
